export default {
  cancellation: {
    DESC_UNKNOWN: 'Invalid cancellation policy',
    DESC_NO_CANCELLATION_AFTER_ISSUED:
      'Cancellation is not possible after voucher exchange or after activity start',
    DESC_UPTO_X_DAYS_BEFORE_WITH_CHARGE:
      'From the booking confirmation date until {{P2}} local time {{if(P1>0){{P1}} days before the participation date else on the day of the event}}, {{CancellationFeeDescription}}.',
    DESC_UPTO_X_HOURS_BEFORE_WITH_CHARGE:
      'Cancellation fees apply from the booking confirmation date up to {{P1}} hours before the scheduled time of participation.',
    DESC_AFTER_X_DAYS_FROM_TIME_WITH_CHARGE:
      '{{CancellationFeeDescription}} applies if cancelled after {{P2}} local time {{P1}} days before participation date',
    DESC_AFTER_X_HOURS_FROM_TIME_WITH_CHARGE:
      'From {{P1}} hours before the scheduled date and time of participation, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_DAYS_WITH_CHARGE:
      '{{CancellationFeeDescription}} applies from {{P2}} local time {{P1}} days before participation date to {{P4}} local time {{P3}} days before',
    DESC_BETWEEN_X_DAYS_TO_Y_HOURS_WITH_CHARGE:
      '{{CancellationFeeDescription}} applies from {{P2}} local time {{P1}} days before participation date to {{P3}} local time on the day',
    DESC_BETWEEN_X_TO_Y_HOURS_WITH_CHARGE:
      'From {{P1}} hours before {{P2}} hours before the scheduled date and time, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_HOURS_TO_0_WITH_CHARGE:
      'From {{P1}} hours before the scheduled date and time of participation until {{P2}} local time on the day of participation, {{CancellationFeeDescription}}',
    DESC_BEFORE_X_DAYS_AFTER_BOOKING_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, the cancellation fee will be charged until {{P1}} local time on the {{P2}}th day.',
    DESC_BEFORE_X_HOURS_AFTER_BOOKING_WITH_CHARGE:
      'Until {{P1}} hours after booking confirmation, {{CancellationFeeDescription}}',
    DESC_AFTER_X_DAYS_FROM_BOOKING_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, from {{P1}} onwards local time on {{P2}}, {{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_BOOKING_WITH_CHARGE:
      'After {{P1}} hours following booking confirmation, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_DAYS_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, the cancellation fee will be charged from local time {{P1}} on the {{P2}}th day until local time {{P3}} on the {{P4}}th day before the participation date.',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_HOURS_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, the cancellation fee will be charged from {{P1}} local time on the {{P2}}th day until {{P3}} hours before the scheduled time of participation.',
    DESC_BETWEEN_BOOKING_HOURS_AND_X_HOURS_WITH_CHARGE:
      'From {{P1}} hours after booking confirmation until {{P2}} hours before the date and time of participation, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_END_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, the cancellation fee will be charged from local time {{P1}} on day {{P2}} to local time {{P3}} on day {{P4}}.',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_HOURS_WITH_CHARGE:
      'Counting the booking confirmation date as day 0, the cancellation fee will be charged from {{P1}} local time on the {{P2}}th day until {{P3}} hours before the booking confirmation date.',
    DESC_BETWEEN_BOOKING_HOURS_START_AND_END_WITH_CHARGE:
      'From {{P1}} hours after booking confirmation to {{P2}} hours before booking confirmation, {{CancellationFeeDescription}}'
  },
  cancellationFeeDescription: {
    FEE_PERCENTAGE:
      '{{value}}% of total order amount will be charged as cancellation fee',
    FEE_FIXED: '{{value}} will be charged as cancellation fee',
    FEE_PER_PARTICIPANT:
      '{{value}} per participant will be charged as cancellation fee',
    FEE_NOT_TO_BE_CANCELLED: 'Cannot Cancel'
  }
};
